<template>
  <div class="dcf-grid-halves@sm dcf-row-gap-5 dcf-col-gap-5">
    <div>
      <svg viewBox="0 0 712 342">
        <use href="#illustration_outline" fill="#CCCCCC" />
        <use href="#bone_fill" fill="#FFFFFF" />
        <use v-for="bone in illustratedBones" :href="'#bone_' + bone" class="clicky_bone" v-on:click.prevent="activeBoneId = bone" />
        <use :href="'#bone_' + activeBoneId" fill="#00FF00" />
        <use href="#bone_outlines" />
      </svg>
    </div>
    <div v-if="activeBoneId">    
      <bone :bone="activeBone" :hideSVG="true"></bone>
    </div>
  </div>

</template>

<style>
.clicky_bone {
  fill: transparent;
  cursor: pointer;
}
.clicky_bone:hover {
  fill: #0000FF;
}
</style>

<script>
import bone from './bone.vue';

export default {
  components: { bone },
  data: function(){
    return {
      bones: [],
      activeBoneId: false,
      nameDisplay: 'scientific',
      illustratedBones: []
    }
  },
  computed: {
    sortedBones: function(){
      var output = this.bones;
      var sortType = (this.nameDisplay == 'scientific' || this.nameDisplay == 'common') ? this.nameDisplay : 'common';

      output = output.sort(function(a, b){
        var key = (sortType == 'scientific') ? 'name' : 'common_name';

        a[key] = (a[key] == null) ? '' : a[key];
        b[key] = (b[key] == null) ? '' : b[key];

        if(a[key].toUpperCase() < b[key].toUpperCase()){
          return -1;
        }
        if(a[key].toUpperCase() > b[key].toUpperCase()){
          return 1;
        }
        return 0;

      });

      return output;
    },
    activeBone: function(){
      var $this = this;
      return this.activeBoneId ? this.bones.find( function(v){ return v.id == $this.activeBoneId }) : false;
    }
  },
  methods: {

  },
  created: function(){
    this.bones = window.bones;
    this.illustratedBones = window.illustrated_bones;
  }
}
</script>

